import React from "react";
import Image from "components/image";
import RichText from "components/rich-text";
import ButtonLink from "components/button-link";
import { Swiper, SwiperSlide } from "components/swiper";
import { Navigation, Mousewheel, Autoplay } from "swiper/modules";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";
import clsx from "clsx/lite";

const ClassicLayout = ({ data }) => {
	const { items, showArrows, settings, title, subtitle } = data;
	const isFluid = settings.isFluid;
	const textColor = { color: data.textColor?.hex };

	const swiperSettings = {
		modules: [Navigation, Mousewheel, Autoplay],
		speed: 2000,
		mousewheel: {
			enabled: true,
			forceToAxis: true,
		},
		navigation: {
			enabled: showArrows,
			nextEl: ".right-arrow-an",
			prevEl: ".left-arrow-an",
			disabledClass: "opacity-0",
		},
		breakpoints: {
			320: { slidesPerView: 1.1 },
			680: { slidesPerView: 2.1 },
			992: { slidesPerView: 3 },
		},
	};

	return (
		<div className={clsx(isFluid && "container-fluid-padding", "flex flex-col items-center")} >
			<h2 style={textColor} className="text-left leading-normal sm:text-center">
				{title}
			</h2>
			{subtitle && (
				<p style={textColor} className="text-white text-center pb-10 sm:pb-20">
					{subtitle}
				</p>
			)}
			<div className="w-full flex">
				<Swiper {...swiperSettings} className="flex w-full overflow-auto no-scrollbar">
					{items.map((item, index) => (
						<SwiperSlide key={index} className={clsx("flex justify-center p-3")}>
							<div key={index} className="flex flex-col" style={{ backgroundColor: item.color?.hex }}>
								{item.image && (
									<div className={clsx("w-full object-cover m-0")}>
										<Image image={item.image} className={clsx("w-full sm:h-[450px] h-[300px] object-cover")} />
									</div>
								)}
								{item.content && (
									<div className={clsx("flex flex-col pt-4")}>
										<RichText data={{ content: item.content }} />
									</div>
								)}
							</div>
						</SwiperSlide>
					))}
					{showArrows && (
						<>
							<button className="left-arrow-an size-10">
								<Arrow className="rotate-180 scale-150 fill-beige" />
							</button>
							<div className="right-arrow-an size-10">
								<Arrow className="scale-150 fill-beige" />
							</div>
						</>
					)}
				</Swiper>
			</div>

			<ButtonLink
				data={data.cta}
				className={clsx("w-full text-center sm:w-auto sm:flex t-become-a-member px-10 p-5 mt-0")}
			/>
		</div>
	);
};

export default ClassicLayout;
